"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckbox = void 0;
const checkbox_1 = require("@pulse-web-ui/checkbox");
const theme_1 = require("@pulse-web-ui/theme");
exports.StyledCheckbox = (0, theme_1.styled)(checkbox_1.Checkbox) `
  div {
    display: flex;
    span {
      display: flex;
      align-items: center;
    }
  }
`;
